import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { useAppDispatch } from "../redux/hooks";
import { 
    loading, 
    openShiftsFetched, 
    openShiftsFetchFailure,
    recipientsFetchedForOpenShift, 
    recipientsForOpenShiftFetchFailure  } from "../redux/slices/openShiftSlice";
import { createUrlWithQueryString } from "../util/url";
import { getPaginationDataFromResponse } from "../util/pagination";
import { OpenShift, OpenShiftRecipient } from "../redux/types";

const useOpenShiftActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getOpenShifts = (
        includeDeleted: boolean,
        fromDate: string | undefined, 
        toDate: string | undefined, 
        pageIndex: number, 
        pageSize: number) => {

        dispatch(loading())

        const params = {
            includeDeleted: includeDeleted,
            fromDate: fromDate,
            toDate: toDate,
            pageNumber: pageIndex,
            pageSize: pageSize
        }

        const url = createUrlWithQueryString(apiConfig.routes.openShifts, params)

        return fetchClient.get(url)
            .then(response => {
                const paginationData = getPaginationDataFromResponse(response.raw)
                dispatch(openShiftsFetched({ shifts: response.data as OpenShift[], totalShiftCount: paginationData?.totalItemCount ?? 0}))
            })
            .catch(error => {
                console.log('getOpenShifts error:', error)
                dispatch(openShiftsFetchFailure(error))
            })
    }

    const getRecipientsForOpenShift = (openShiftId: string) => {
        dispatch(loading())

        const url = apiConfig.routes.openShifts + `${openShiftId}/recipients` 

        return fetchClient.get(url)
            .then(response => {
                dispatch(recipientsFetchedForOpenShift({openShiftId: openShiftId, openShiftRecipients: response.data as OpenShiftRecipient[]}))
            })
            .catch(error => {
                console.log('getRecipientsForOpenShift error:', error)
                dispatch(recipientsForOpenShiftFetchFailure(error))
            })
    }

    return {
        getOpenShifts,
        getRecipientsForOpenShift
    }
}

export default useOpenShiftActions